import { Controller } from '@hotwired/stimulus'

const DETAILS_STORAGE_KEY = 'productSpecFiltersOpen'

export default class extends Controller {
  static targets = ['search', 'details', 'form']

  connect() {
    this.timeout = null
    this.restoreDetails()
  }

  // The form is re-rendered on every turbo-frame submit, which resets
  // the <details> element; restore the user's last explicit toggle.
  restoreDetails() {
    if (!this.hasDetailsTarget) return

    const stored = sessionStorage.getItem(DETAILS_STORAGE_KEY)
    if (stored !== null) this.detailsTarget.open = stored === '1'
  }

  persistDetails() {
    sessionStorage.setItem(DETAILS_STORAGE_KEY, this.detailsTarget.open ? '1' : '0')
  }

  // The search input is data-turbo-permanent, so a frame reload keeps its
  // text; clear it explicitly when filters are reset.
  clearSearch() {
    if (this.hasSearchTarget) this.searchTarget.value = ''
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  filter() {
    this.submitWithDelay(300)
  }

  // Cart quantity fields: an empty or below-one value must NOT submit, else
  // clearing the field to retype a number would send a blank quantity and the
  // server would read it as 0 and delete the line item.
  quantity(event) {
    const value = parseInt(event.target.value, 10)
    if (!Number.isInteger(value) || value < 1) return

    this.submitWithDelay(300)
  }

  search() {
    const value = this.searchTarget.value
    if (value.length > 0 && value.length < 3) return

    this.submitWithDelay(300)
  }

  submitWithDelay(ms) {
    if (this.timeout) clearTimeout(this.timeout)
    const form = this.hasFormTarget ? this.formTarget : this.element
    this.timeout = setTimeout(() => this.submitWithoutBlanks(form), ms)
  }

  // Blank text/number inputs are excluded from the GET submit so the URL
  // doesn't accumulate empty params like ?price_min=&price_max=
  submitWithoutBlanks(form) {
    const blanks = Array.from(form.elements).filter(
      (el) =>
        el.name &&
        !el.disabled &&
        el.value === '' &&
        ['text', 'search', 'number', 'email', 'tel'].includes(el.type)
    )
    blanks.forEach((el) => {
      el.disabled = true
    })
    form.requestSubmit()
    setTimeout(() => {
      blanks.forEach((el) => {
        el.disabled = false
      })
    }, 150)
  }
}
